package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ExistingAssessmentResponse(
    val data: List<ExistingAssessment>,
)

@Serializable
data class ExistingAssessment(
    @SerialName("_attachments")
    val attachments: String,
    @SerialName("_etag")
    val etag: String,
    @SerialName("_rid")
    val rid: String,
    @SerialName("_self")
    val self: String,
    @SerialName("_ts")
    val ts: Long,
    val adminMessage: String,
    val category: String,
    val id: String,
    val isAdminRead: Boolean = false,
    val isRead: Boolean = false,
    val message: String,
    val organization: String,
    @SerialName("receiverID")
    val receiverId: String,
    val reminder: Long? = 0,
    val senderEmail: String,
    @SerialName("senderID")
    val senderId: String = "",
    val senderName: String,
    val timestamp: String,
    val title: String,
    val type: String,
    val requestedBy: String? = "",
)

@Serializable
data class ExistingAssessmentPayload(
    @SerialName("userID")
    val userId: String,
    val organization: String,
    val requestedBy: String,
    val seasonID: String
)
